export interface ProductLink {
  label: string;
  type: "hotel" | "tour" | "car" | "guide";
  path: string;
  price: string;
  rating: string;
  location: string;
}

export interface DiscoverPost {
  id: number;
  title: string;
  cover: string;
  avatar: string;
  username: string;
  likes: number;
  comments: number;
  tags: string[];
  productLink: ProductLink | null;
  // 详情页字段
  content: string;
  images: string[];
  location: string;
  publishTime: string;
  relatedProducts: RelatedProduct[];
}

export interface RelatedProduct {
  id: string;
  type: "hotel" | "tour" | "car" | "guide";
  name: string;
  desc: string;
  price: string;
  priceUnit: string;
  rating: string;
  reviewCount: number;
  image: string;
  path: string;
  tags: string[];
}

export const discoverPosts: DiscoverPost[] = [
  {
    id: 1,
    title: "三亚5天4晚完美攻略｜超详细行程安排",
    cover: "https://readdy.ai/api/search-image?query=Sanya%20travel%20blog%20cover%20showing%20beautiful%20beach%20sunset%20with%20golden%20sky%2C%20silhouette%20of%20palm%20trees%2C%20couple%20walking%20on%20beach%2C%20warm%20romantic%20atmosphere%2C%20travel%20lifestyle%20photography&width=200&height=260&seq=101&orientation=portrait",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20woman%20avatar%20portrait%20smiling%20warmly%2C%20casual%20style%2C%20clean%20background%2C%20profile%20photo%20style&width=40&height=40&seq=201&orientation=squarish",
    username: "旅行达人小林",
    likes: 3241,
    comments: 186,
    tags: ["三亚", "海岛"],
    productLink: { label: "查看推荐酒店", type: "hotel", path: "/hotel-detail-product", price: "¥980", rating: "4.9", location: "三亚·亚龙湾" },
    location: "三亚市 · 亚龙湾",
    publishTime: "2024-04-10",
    content: "刚刚结束了一段超级治愈的三亚之旅，忍不住想把这5天的完整攻略分享给大家！\n\n第一天：抵达三亚，入住亚龙湾海景酒店，下午去海滩散步，晚上吃了当地超级新鲜的海鲜大排档。\n\n第二天：蜈支洲岛一日游！这里的水真的清到透底，浮潜看到了各种热带鱼，太治愈了。建议早上第一班船过去，游客少、景色最美。\n\n第三天：南山文化旅游区+大小洞天。南山的海上观音气场很强，大小洞天的山海风光别有一番韵味。\n\n第四天：亚特兰蒂斯水世界，带孩子来必打卡！大人也玩得很嗨，海浪池和漂流河超级好玩。\n\n第五天：天涯海角，感受一下\"海枯石烂\"的浪漫，然后去免税店扫货，下午飞回家。\n\n整体花费：4人大约1.8万，住宿占大头，建议提前2个月预订。",
    images: [
      "https://readdy.ai/api/search-image?query=Sanya%20Yalong%20Bay%20crystal%20clear%20turquoise%20sea%20resort%20beach%20white%20sand%20tropical%20vacation%20summer%20bright%20sunshine%20aerial&width=400&height=300&seq=d101a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Wuzhizhou%20Island%20snorkeling%20underwater%20colorful%20tropical%20fish%20coral%20reef%20clear%20water%20Sanya%20China%20travel&width=400&height=300&seq=d101b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sanya%20beach%20sunset%20golden%20hour%20silhouette%20couple%20palm%20tree%20romantic%20tropical%20paradise%20evening%20sky&width=400&height=300&seq=d101c&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sanya%20Nanshan%20temple%20sea%20view%20Buddha%20statue%20cultural%20tourism%20scenic%20spot%20China%20travel%20photography&width=400&height=300&seq=d101d&orientation=landscape",
    ],
    relatedProducts: [
      {
        id: "p101",
        type: "hotel",
        name: "亚龙湾海景度假酒店",
        desc: "直面海景豪华大床房，内含早餐",
        price: "¥980",
        priceUnit: "/ 间·晚",
        rating: "4.9",
        reviewCount: 2341,
        image: "https://readdy.ai/api/search-image?query=luxury%20beach%20resort%20hotel%20room%20ocean%20view%20large%20window%20tropical%20Sanya%20modern%20interior%20design%20warm%20tones&width=300&height=200&seq=rp101a&orientation=landscape",
        path: "/hotel-detail-product",
        tags: ["海景房", "含早餐", "五星级"],
      },
      {
        id: "p102",
        type: "tour",
        name: "三亚5天4晚精品游",
        desc: "含蜈支洲岛+南山+亚特兰蒂斯，全程导游",
        price: "¥3,980",
        priceUnit: "/ 人",
        rating: "4.8",
        reviewCount: 876,
        image: "https://readdy.ai/api/search-image?query=Sanya%20travel%20tour%20group%20visiting%20Wuzhizhou%20Island%20beach%20snorkeling%20scenic%20spot%20tourism%20beautiful%20tropical%20destination&width=300&height=200&seq=rp102a&orientation=landscape",
        path: "/route-detail-product",
        tags: ["全程导游", "含门票", "亲子首选"],
      },
    ],
  },
  {
    id: 2,
    title: "大理洱海骑行日记：一个人也能很自在",
    cover: "https://readdy.ai/api/search-image?query=Erhai%20Lake%20cycling%20trip%20scenic%20photo%20with%20bicycle%20on%20lakeside%20road%2C%20clear%20blue%20water%20reflection%2C%20mountains%20in%20background%2C%20solo%20travel%20adventure%2C%20lifestyle%20photography&width=200&height=300&seq=102&orientation=portrait",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20man%20avatar%20portrait%20casual%20outdoor%20style%2C%20friendly%20expression%2C%20natural%20lighting%2C%20profile%20photo&width=40&height=40&seq=202&orientation=squarish",
    username: "骑行少年阿杰",
    likes: 1892,
    comments: 94,
    tags: ["大理", "骑行", "solo旅行"],
    productLink: { label: "查看租车方案", type: "car", path: "/car-detail-product", price: "¥128", rating: "4.7", location: "大理·洱海" },
    location: "大理市 · 洱海沿线",
    publishTime: "2024-03-28",
    content: "一个人骑行洱海，是我今年做得最对的决定。\n\n租了辆电助力自行车，从古城出发，沿洱海东线骑行。全程约80公里，我骑了一整天，中途停了无数次拍照，每一处都美得不行。\n\n推荐路线：大理古城→挖色镇→双廊古镇→环海路→大理古城。\n\n双廊绝对是最值得停留的地方，慢慢逛各种独立小店，随便找家咖啡馆坐下来，看着洱海发呆，一下午就过去了。\n\n骑行贴士：\n- 电助力车租金约80-120元/天，押金500元\n- 一定要早出发，下午洱海边风大\n- 建议从古城西门这边的租车店租，口碑更好\n- 携带防晒，高原紫外线真的强",
    images: [
      "https://readdy.ai/api/search-image?query=Erhai%20Lake%20Dali%20cycling%20road%20bicycle%20mountain%20scenery%20clear%20blue%20water%20reflections%20solo%20travel%20peaceful%20morning&width=400&height=300&seq=d102a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Shuanglang%20ancient%20town%20Erhai%20Lake%20waterfront%20cafe%20view%20peaceful%20Yunnan%20China%20travel%20photography%20warm%20afternoon&width=400&height=300&seq=d102b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Dali%20ancient%20city%20traditional%20Bai%20architecture%20gate%20tower%20blue%20sky%20white%20clouds%20Yunnan%20China%20travel&width=400&height=300&seq=d102c&orientation=landscape",
    ],
    relatedProducts: [
      {
        id: "p201",
        type: "car",
        name: "洱海电助力自行车",
        desc: "适合骑行洱海全程，有电助力更省力",
        price: "¥99",
        priceUnit: "/ 天",
        rating: "4.7",
        reviewCount: 1203,
        image: "https://readdy.ai/api/search-image?query=electric%20bicycle%20rental%20shop%20Dali%20Yunnan%20China%20tourist%20cycling%20equipment%20clean%20white%20background%20product%20display&width=300&height=200&seq=rp201a&orientation=landscape",
        path: "/car-detail-product",
        tags: ["电助力", "免押金", "含头盔"],
      },
      {
        id: "p202",
        type: "tour",
        name: "洱海骑行一日游",
        desc: "专业领队带队，环洱海精华路线",
        price: "¥199",
        priceUnit: "/ 人",
        rating: "4.8",
        reviewCount: 456,
        image: "https://readdy.ai/api/search-image?query=cycling%20tour%20group%20at%20Erhai%20Lake%20Dali%20Yunnan%20beautiful%20scenery%20guided%20tour%20travel%20activity%20outdoor&width=300&height=200&seq=rp202a&orientation=landscape",
        path: "/route-detail-product",
        tags: ["领队陪同", "含午餐", "小团游"],
      },
    ],
  },
  {
    id: 3,
    title: "成都美食地图：48小时吃垮成都",
    cover: "https://readdy.ai/api/search-image?query=Chengdu%20street%20food%20photography%20showing%20spicy%20hotpot%20mapo%20tofu%20and%20local%20snacks%2C%20vibrant%20colors%2C%20steam%20rising%2C%20food%20travel%20blog%20style&width=200&height=240&seq=103&orientation=portrait",
    avatar: "https://readdy.ai/api/search-image?query=chinese%20food%20blogger%20woman%20avatar%20portrait%20happy%20expression%2C%20casual%20style%2C%20warm%20background%2C%20profile%20photo&width=40&height=40&seq=203&orientation=squarish",
    username: "吃货探店Elena",
    likes: 5673,
    comments: 342,
    tags: ["成都", "美食"],
    productLink: { label: "查看成都线路", type: "tour", path: "/route-detail-product", price: "¥1,580", rating: "4.9", location: "成都" },
    location: "成都市 · 锦里",
    publishTime: "2024-04-02",
    content: "成都48小时美食挑战圆满完成！嘴巴和胃都在诉说着幸福。\n\n第一顿：锦里附近的老字号火锅，红汤九宫格，毛肚脆嫩，鸭肠爽滑，肯定要配一瓶冰镇醪糟。\n\n第二顿：文殊院素面，清晨的庙前吃一碗素面，有种难以言说的宁静。\n\n第三顿：春熙路商圈的钵钵鸡，一串串捞出来吃，麻辣鲜香，停不下来。\n\n第四顿：太古里旁边藏着家川菜馆子，夫妻肺片和麻婆豆腐是绝对主角，下饭神器。\n\n第五顿：双流老妈兔头，拿着兔头啃，这才是成都人的快乐。\n\n第六顿：宽窄巷子随便找家小店，甜水面+叶儿粑，完美收尾。\n\n不用准备什么攻略，在成都，你只要会走路，就能找到好吃的。",
    images: [
      "https://readdy.ai/api/search-image?query=Chengdu%20spicy%20hotpot%20red%20broth%20nine%20grid%20boiling%20mala%20maodu%20duck%20intestine%20traditional%20Sichuan%20food%20steaming%20atmosphere&width=400&height=300&seq=d103a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Chengdu%20Jinli%20ancient%20street%20food%20stalls%20lanterns%20night%20market%20traditional%20Sichuan%20architecture%20tourism&width=400&height=300&seq=d103b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Chengdu%20Taikoo%20Li%20shopping%20street%20modern%20architecture%20outdoor%20mall%20people%20walking%20daytime%20urban%20travel%20lifestyle&width=400&height=300&seq=d103c&orientation=landscape",
    ],
    relatedProducts: [
      {
        id: "p301",
        type: "tour",
        name: "成都3天美食文化游",
        desc: "含大熊猫基地、锦里、宽窄巷子，专车接送",
        price: "¥1,580",
        priceUnit: "/ 人",
        rating: "4.9",
        reviewCount: 1876,
        image: "https://readdy.ai/api/search-image?query=Chengdu%20panda%20base%20giant%20panda%20bamboo%20cute%20tour%20group%20travel%20attraction%20popular%20destination%20China%20tourism&width=300&height=200&seq=rp301a&orientation=landscape",
        path: "/route-detail-product",
        tags: ["含熊猫基地", "专属导游", "含午餐"],
      },
    ],
  },
  {
    id: 4,
    title: "厦门鼓浪屿隐藏小路，避开人群才能看到",
    cover: "https://readdy.ai/api/search-image?query=Gulangyu%20island%20Xiamen%20hidden%20quiet%20alley%20with%20colorful%20colonial%20buildings%2C%20bougainvillea%20flowers%2C%20morning%20light%2C%20travel%20photography%20artistic%20style&width=200&height=280&seq=104&orientation=portrait",
    avatar: "https://readdy.ai/api/search-image?query=chinese%20travel%20photographer%20man%20portrait%20artistic%20style%2C%20casual%20clothes%2C%20outdoor%20background%2C%20profile%20photo&width=40&height=40&seq=204&orientation=squarish",
    username: "摄影师老陈",
    likes: 2108,
    comments: 127,
    tags: ["厦门", "摄影"],
    productLink: null,
    location: "厦门市 · 鼓浪屿",
    publishTime: "2024-03-15",
    content: "鼓浪屿，被游客踏遍了的地方，但我还是找到了那些没人知道的角落。\n\n秘密路线：从轮渡码头上岛后，不要跟着人群往日光岩方向走。往左边走，沿着鼓声路往里深入，会经过一些老居民的生活区，保留着最原始的生活气息。\n\n发现了一个被爬山虎覆盖的老洋楼，早晨阳光斜射进来，光影绝了。\n\n还有一条无名小巷，两侧都是三角梅，花期正好，粉色的、紫色的，密密麻麻，拍出来超级梦幻。\n\n摄影建议：\n- 最佳时间：早上7-9点，游客少、光线好\n- 带一支35mm或50mm定焦，适合街拍\n- 岛上有很多独立咖啡馆，随便推开一家都有惊喜\n- 下午可以找高处俯拍海景，黄昏时分海天一色，非常壮观",
    images: [
      "https://readdy.ai/api/search-image?query=Gulangyu%20alley%20bougainvillea%20flowers%20pink%20purple%20colonial%20building%20Xiamen%20morning%20light%20photography%20artistic%20travel&width=400&height=300&seq=d104a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Xiamen%20Gulangyu%20old%20colonial%20architecture%20ivy%20covered%20building%20golden%20sunlight%20peaceful%20morning%20residential%20street&width=400&height=300&seq=d104b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Xiamen%20Gulangyu%20panoramic%20sea%20view%20sunset%20orange%20sky%20island%20harbor%20boats%20cityscape%20photography&width=400&height=300&seq=d104c&orientation=landscape",
    ],
    relatedProducts: [
      {
        id: "p401",
        type: "guide",
        name: "鼓浪屿摄影专属导游",
        desc: "懂摄影的本地达人，带你找最美机位",
        price: "¥380",
        priceUnit: "/ 半天",
        rating: "5.0",
        reviewCount: 312,
        image: "https://readdy.ai/api/search-image?query=professional%20travel%20guide%20photographer%20Xiamen%20Gulangyu%20island%20tour%20local%20expert%20guiding%20tourist%20photography%20trip&width=300&height=200&seq=rp401a&orientation=landscape",
        path: "/guide-detail-product",
        tags: ["摄影达人", "中英双语", "小团专属"],
      },
    ],
  },
  {
    id: 5,
    title: "亲子游必看！三亚带娃全攻略（2024最新）",
    cover: "https://readdy.ai/api/search-image?query=family%20vacation%20at%20Sanya%20beach%20with%20happy%20parents%20and%20kids%20playing%20in%20shallow%20crystal%20water%2C%20bright%20sunny%20day%2C%20family%20travel%20photography%20joyful%20lifestyle&width=200&height=260&seq=105&orientation=portrait",
    avatar: "https://readdy.ai/api/search-image?query=young%20chinese%20mother%20avatar%20portrait%20gentle%20warm%20smile%2C%20casual%20wear%2C%20outdoor%20natural%20light%2C%20profile%20photo&width=40&height=40&seq=205&orientation=squarish",
    username: "宝妈旅行家晓雨",
    likes: 4320,
    comments: 289,
    tags: ["三亚", "亲子", "攻略"],
    productLink: { label: "查看亲子线路", type: "tour", path: "/route-detail-product", price: "¥2,680", rating: "4.9", location: "三亚" },
    location: "三亚市 · 海棠湾",
    publishTime: "2024-04-05",
    content: "作为一个带着两娃出行的宝妈，这次三亚亲子游整体来说超级成功！分享给同样有娃的家长们。\n\n酒店选择：推荐海棠湾片区，有免税店可以顺路购物，且酒店大多配有儿童泳池和沙滩，孩子们玩得不亦乐乎。\n\n必打卡：亚特兰蒂斯水世界，大人小孩都疯了！各种水上项目，胆大的可以挑战大浪，胆小的海浪池就够了。\n\n蜈支洲岛：适合6岁以上的孩子，水质清澈，可以租浮潜设备，孩子第一次看到海里的鱼，眼睛都放光了。\n\n贴心提示：\n- 带上防晒喷雾，三亚的太阳真的很毒\n- 建议在酒店订早餐，带娃外出吃早饭真的很折腾\n- 景区门票提前网上购买，现场排队要命\n- 孩子的防晒衣和游泳装备一定要带够",
    images: [
      "https://readdy.ai/api/search-image?query=Atlantis%20water%20park%20Sanya%20family%20children%20water%20slides%20wave%20pool%20happy%20kids%20summer%20vacation%20tropical&width=400&height=300&seq=d105a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Sanya%20Haitang%20Bay%20luxury%20resort%20beach%20family%20vacation%20kids%20playing%20sand%20beach%20resort%20hotel%20backdrop&width=400&height=300&seq=d105b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Wuzhizhou%20Island%20snorkeling%20with%20kids%20family%20underwater%20experience%20clear%20turquoise%20water%20tropical%20fish&width=400&height=300&seq=d105c&orientation=landscape",
    ],
    relatedProducts: [
      {
        id: "p501",
        type: "tour",
        name: "三亚亲子5日游",
        desc: "含蜈支洲岛+亚特兰蒂斯，亲子专线",
        price: "¥2,680",
        priceUnit: "/ 人",
        rating: "4.9",
        reviewCount: 2103,
        image: "https://readdy.ai/api/search-image?query=family%20travel%20tour%20Sanya%20kids%20beach%20water%20activities%20guided%20trip%20happy%20vacation%20tropical%20destination%20China%20summer&width=300&height=200&seq=rp501a&orientation=landscape",
        path: "/route-detail-product",
        tags: ["亲子专线", "含门票", "儿童优惠"],
      },
      {
        id: "p502",
        type: "hotel",
        name: "海棠湾海棠之星度假村",
        desc: "儿童乐园+沙滩直达，亲子首选",
        price: "¥1,280",
        priceUnit: "/ 间·晚",
        rating: "4.8",
        reviewCount: 987,
        image: "https://readdy.ai/api/search-image?query=Sanya%20Haitang%20Bay%20family%20resort%20hotel%20kids%20club%20pool%20beach%20view%20tropical%20luxury%20vacation&width=300&height=200&seq=rp502a&orientation=landscape",
        path: "/hotel-detail-product",
        tags: ["儿童乐园", "直达沙滩", "含早餐"],
      },
    ],
  },
  {
    id: 6,
    title: "云南大理：那些年我们追过的浪漫",
    cover: "https://readdy.ai/api/search-image?query=romantic%20sunset%20at%20Dali%20Yunnan%20with%20couple%20silhouette%20by%20Erhai%20Lake%2C%20dramatic%20orange%20sky%20reflection%2C%20peaceful%20scenery%2C%20travel%20romantic%20photography&width=200&height=300&seq=106&orientation=portrait",
    avatar: "https://readdy.ai/api/search-image?query=chinese%20couple%20travel%20blogger%20woman%20portrait%20romantic%20style%2C%20natural%20makeup%2C%20outdoor%20scenery%20background%2C%20lifestyle%20profile%20photo&width=40&height=40&seq=206&orientation=squarish",
    username: "行走的玫瑰",
    likes: 3876,
    comments: 215,
    tags: ["大理", "旅拍", "情侣"],
    productLink: { label: "查看推荐酒店", type: "hotel", path: "/hotel-detail-product", price: "¥680", rating: "4.8", location: "大理·古城" },
    location: "大理市 · 古城",
    publishTime: "2024-03-20",
    content: "和另一半去大理，只想做一件事：什么都不想，什么都不干，感受时间的流动。\n\n住在古城里一家庭院民宿，推开门就是一片三角梅，早晨坐在院子里喝普洱茶，听着远处的风声，整个人都安静下来了。\n\n洱海边的日落是此行最美的记忆。我们骑车到海边，找了个没什么人的小码头，坐在上面看太阳一点点沉入洱海，天空从金橙色变成深紫，太美了。\n\n旅拍建议：\n- 大理古城正午阳光很强，适合找有树荫的街巷拍\n- 洱海日落拍人像，逆光效果绝美\n- 双廊有很多专业旅拍摄影师，提前约好性价比很高\n- 服饰推荐带白色或米色系，和大理的色调很配",
    images: [
      "https://readdy.ai/api/search-image?query=Dali%20ancient%20city%20courtyard%20guesthouse%20bougainvillea%20romantic%20couple%20travel%20blooming%20flowers%20white%20wall%20traditional%20architecture&width=400&height=300&seq=d106a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Erhai%20Lake%20sunset%20golden%20hour%20couple%20silhouette%20dock%20pier%20dramatic%20sky%20reflection%20romantic%20Yunnan%20travel&width=400&height=300&seq=d106b&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Shuanglang%20Erhai%20Lake%20photography%20couple%20portrait%20backlight%20sunset%20warm%20tones%20romantic%20travel%20lifestyle%20Yunnan&width=400&height=300&seq=d106c&orientation=landscape",
    ],
    relatedProducts: [
      {
        id: "p601",
        type: "hotel",
        name: "大理古城庭院精品民宿",
        desc: "独院三角梅庭院，洱海观景台，含早餐",
        price: "¥680",
        priceUnit: "/ 间·晚",
        rating: "4.8",
        reviewCount: 654,
        image: "https://readdy.ai/api/search-image?query=Dali%20Yunnan%20boutique%20guesthouse%20courtyard%20bougainvillea%20flowers%20traditional%20architecture%20cozy%20romantic%20interior%20warm%20tones&width=300&height=200&seq=rp601a&orientation=landscape",
        path: "/hotel-detail-product",
        tags: ["独院庭院", "含早餐", "情侣推荐"],
      },
      {
        id: "p602",
        type: "guide",
        name: "大理旅拍定制导游",
        desc: "本地摄影师，双廊洱海旅拍专属定制",
        price: "¥580",
        priceUnit: "/ 天",
        rating: "5.0",
        reviewCount: 218,
        image: "https://readdy.ai/api/search-image?query=Dali%20photography%20guide%20couple%20travel%20portrait%20shooting%20Erhai%20Lake%20scenic%20professional%20photographer%20local%20expert&width=300&height=200&seq=rp602a&orientation=landscape",
        path: "/guide-detail-product",
        tags: ["旅拍专属", "可出片", "情侣套餐"],
      },
    ],
  },
];
